module.exports = __webpack_public_path__ + "static/media/chatIcon2.a34ea9dd.svg";